import { render, staticRenderFns } from "./PayForHouse.vue?vue&type=template&id=138eb39d"
import script from "./PayForHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./PayForHouse.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports